/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ArchiveUserInput = {
    userId: string;
    clientMutationId?: string | null | undefined;
};
export type archiveUserMutationVariables = {
    input: ArchiveUserInput;
};
export type archiveUserMutationResponse = {
    readonly archiveUser: {
        readonly clientMutationId: string | null;
        readonly user: {
            readonly __typename: string;
            readonly archived: boolean | null;
        };
    } | null;
};
export type archiveUserMutation = {
    readonly response: archiveUserMutationResponse;
    readonly variables: archiveUserMutationVariables;
};



/*
mutation archiveUserMutation(
  $input: ArchiveUserInput!
) {
  archiveUser(input: $input) {
    clientMutationId
    user {
      __typename
      archived
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "archiveUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ArchiveUserPayload",
        "kind": "LinkedField",
        "name": "archiveUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "archiveUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ArchiveUserPayload",
        "kind": "LinkedField",
        "name": "archiveUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "74ed1b5aba1903ca7a1c1aa0f76b3b05",
    "id": null,
    "metadata": {},
    "name": "archiveUserMutation",
    "operationKind": "mutation",
    "text": "mutation archiveUserMutation(\n  $input: ArchiveUserInput!\n) {\n  archiveUser(input: $input) {\n    clientMutationId\n    user {\n      __typename\n      archived\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f71e1ecd582bc297fe6982a5de50ba98';
export default node;
